<div class="entity-config-page container-fluid">
  <div class="entity-config-shell d-flex flex-column gap-0 mx-auto position-relative">
    <blocking-loader-overlay
      :show="loading_scope_cases"
      :message="page_loading_message"
      :detail="page_loading_detail"
    />
    <section class="entity-config-top rounded-4 overflow-hidden shadow-sm mb-1">
      <div class="entity-config-top-hero px-2 px-md-2 pt-2 pb-1">
        <div class="row g-2 align-items-start">
          <div class="col">
            <div class="entity-page-title lh-sm mb-1 mt-2">Scope dashboard</div>
          </div>
        </div>
      </div>

      <div class="px-2 px-md-2 pb-0">
        <div class="scope-dashboard-banner rounded-4 border shadow-sm p-3 mb-2 d-flex align-items-start gap-3">
          <div class="min-w-0">
            <div class="d-flex flex-wrap align-items-center gap-2 mb-1">
              <div class="fw-semibold text-dark">{{ scope_banner_title }}</div>
            </div>
            <div class="entity-panel-caption text-dark small">
              {{ scope_banner_copy }}
            </div>
          </div>
        </div>
        <section class="row entity-config-top-metrics g-2">
          <div v-for="metric in metrics" :key="metric.label" class="col-12 col-sm-6 col-xl-3 mb-2">
            <article class="entity-metric-card h-100 rounded-4 border shadow-sm p-3">
              <div class="d-flex align-items-start justify-content-between gap-3">
                <div class="d-flex flex-column justify-content-start pt-1 ps-2">
                  <span class="entity-metric-label secondary-color text-uppercase d-block mb-2">
                    {{ metric.label }}
                  </span>
                  <div class="entity-metric-value secondary-color lh-1 mb-0 mt-1">{{ metric.value }}</div>
                  <div class="text-x mb-0 mt-2" :class="metric.change_class">{{ metric.change }}</div>
                </div>
              </div>
            </article>
          </div>
        </section>
      </div>
    </section>

    

    <section class="row g-0 mt-0">
      <div class="col-12 p-0 m-0">
        <div class="entity-detail-panel rounded-4 border-0 p-2 h-100 mt-0">
          <div class="d-flex align-items-center justify-content-between gap-2 mb-3">
            <div>
              <h2 class="company-cases-section-title mb-1">Assigned cases</h2>
              <div class="entity-panel-caption text-dark small">Live cases routed to you for coordination, review, and follow-up.</div>
            </div>
            <button type="button" class="company-cases-new-btn" @click="open_register_case">+ Register a case</button>
          </div>

          <div class="company-cases-table-wrap shadow">
            <div class="table-responsive">
              <table class="table company-cases-table align-middle mb-0">
                <thead>
                  <tr>
                    <th>Case</th>
                    <th>Domain</th>
                    <th>Case owner</th>
                    <th>Risk</th>
                    <th>SLA</th>
                    <th class="text-end">Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in scope_cases" :key="`${item.case_code}-${item.panel_member}`" class="case-clickable-row" @click="go_to_case_detail(item)">
                    <td>
                      <div class="company-case-title">{{ item.title }}</div>
                      <div class="company-case-subtitle">{{ item.subtitle }}</div>
                    </td>
                    <td>
                      <span class="company-case-domain" :class="item.domain_badge_class">
                        {{ item.domain }}
                      </span>
                    </td>
                    <td>
                      <div class="company-case-owner">{{ item.panel_member }}</div>
                    </td>
                    <td>
                      <span class="company-case-risk" :class="item.risk_badge_class">
                        {{ item.risk_score }} <span class="company-case-risk-separator">·</span> {{ item.risk_label }}
                      </span>
                    </td>
                    <td>
                      <span class="company-case-sla" :class="item.sla_class">
                        <i v-if="item.sla_icon" class="bi" :class="item.sla_icon"></i>
                        <span class="company-case-sla-text">{{ item.sla }}</span>
                      </span>
                    </td>
                    <td class="text-end">
                      <div class="company-case-actions">
                        <button
                          type="button"
                          class="company-case-view-btn"
                          @click.stop="go_to_case_detail(item)"
                        >
                          View case
                        </button>
                      </div>
                    </td>
                  </tr>
                  <tr v-if="!loading_scope_cases && !scope_cases.length">
                    <td colspan="6" class="py-4 text-center text-secondary">No open cases are assigned to you right now.</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>

  <div
    v-if="show_manual_case_modal"
    class="company-case-modal-backdrop d-flex align-items-center justify-content-center"
    @click.self="close_manual_case_modal"
  >
    <section class="company-case-modal bg-white manual-intake-modal position-relative">
      <blocking-loader-overlay
        :show="submitting_manual_case"
        message="Registering case..."
        detail="Please wait while the case and its requestor form are being saved."
      ></blocking-loader-overlay>
      <header class="company-case-modal-header d-flex align-items-start justify-content-between gap-3">
        <div>
          <h2 class="company-case-modal-title mb-2">{{ manual_case.title }}</h2>
          <div class="company-case-modal-copy">{{ manual_case.subtitle }}</div>
        </div>
        <button type="button" class="company-case-modal-close btn border-0 p-0" aria-label="Close modal" @click="close_manual_case_modal">
          <i class="bi bi-x-lg"></i>
        </button>
      </header>

      <div class="company-case-modal-body">
        <div v-if="manual_case_error" class="small text-danger fw-semibold mb-3" role="alert">
          {{ manual_case_error }}
        </div>
        <p v-if="manual_case.description" class="mb-4 company-case-modal-description">
          {{ manual_case.description }}
        </p>
        <div class="mb-3">
          <label class="company-case-modal-label text-uppercase mb-2" for="scope_manual_intake_requester">Requester<span class="manual-required-marker">*</span></label>
          <input
            id="scope_manual_intake_requester"
            v-model.trim="manual_case.requester"
            type="text"
            class="form-control company-case-modal-control"
            placeholder="Full name"
            :disabled="submitting_manual_case"
          >
        </div>

        <div class="mb-3">
          <label class="company-case-modal-label text-uppercase mb-2" for="scope_manual_intake_contact">Contact</label>
          <input
            id="scope_manual_intake_contact"
            v-model.trim="manual_case.contact"
            type="text"
            class="form-control company-case-modal-control"
            placeholder="Phone or email"
            :disabled="submitting_manual_case"
          >
        </div>

        <div class="mb-3">
          <label class="company-case-modal-label text-uppercase mb-2" for="scope_manual_intake_location">Location / Address</label>
          <input
            id="scope_manual_intake_location"
            v-model.trim="manual_case.location"
            type="text"
            class="form-control company-case-modal-control"
            placeholder="Address or area"
            :disabled="submitting_manual_case"
          >
        </div>

        <div class="mb-0">
          <label class="company-case-modal-label text-uppercase mb-2" for="scope_manual_intake_case_type">Case type<span class="manual-required-marker">*</span></label>
          <select
            id="scope_manual_intake_case_type"
            v-model="manual_case.case_type"
            class="form-select company-case-modal-control"
            :disabled="submitting_manual_case"
          >
            <option value="" disabled>Select a case type</option>
            <option v-for="option in case_type_options" :key="option.id" :value="option.id">{{ option.label }}</option>
          </select>
        </div>
      </div>

      <footer class="company-case-modal-footer d-flex justify-content-end gap-2">
        <button type="button" class="btn btn-light border px-4" :disabled="submitting_manual_case" @click="close_manual_case_modal">
          Need more info
        </button>
        <button type="button" class="btn btn-primary-dark px-4" :disabled="!can_submit_manual_case()" @click="submit_manual_case">
          {{ submitting_manual_case ? 'Registering...' : 'Register -> onto main DB' }}
        </button>
      </footer>
    </section>
  </div>
</div>
